import api from './api';

export interface CreateRedirectDto {
  slug: string;
  url: string;
}

export interface Redirect {
  id: string;
  slug: string;
  url: string;
  totalClicks: number;
  uniqueClicks: number;
  createdAt: string;
}

const base = '/redirects';

const VISITOR_ID_KEY = 'tg_stars_redirect_visitor';

export function getOrCreateVisitorId(): string {
  let id = localStorage.getItem(VISITOR_ID_KEY);
  if (!id) {
    id = `v_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
    localStorage.setItem(VISITOR_ID_KEY, id);
  }
  return id;
}

export const redirectsApi = {
  create: (data: CreateRedirectDto) => api.post<{ id: string; slug: string; url: string }>(base, data).then((r) => r.data),
  getMine: () => api.get<Redirect[]>(`${base}/me`).then((r) => r.data),
  delete: (id: string) => api.delete(`${base}/${id}`),
  resolve: (slug: string) => api.get<{ url: string }>(`${base}/r/${slug}`).then((r) => r.data),
  track: (slug: string, visitorId?: string | null) =>
    api.post(`${base}/track`, { slug, visitorId }, { timeout: 5000 }).catch(() => {}),
};
